import React from "react";

const PasswordChangedModal = ({ onClose }) => {
	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
			<div className="bg-white rounded-[8px] w-[416px] h-[162px] p-[32px] flex flex-col justify-between">
				<div className="flex items-center gap-[16px] w-[352px] h-[55px]">
					<img
						src="/assets/forgot-password/img1.svg"
						alt="Success Icon"
						className="w-[24px] h-[24px]"
					/>
					<p className="font-montserrat font-[400] text-[12px] leading-[100%] text-[#262A29]">
						Your password has been changed. You can now log in with your new
						credentials.
					</p>
				</div>

				<div className="flex justify-end">
					<button
						onClick={onClose}
						className="bg-[#B7D974] rounded-full w-[90px] h-[32px] p-[8px] flex items-center justify-center"
					>
						<span className="font-montserrat font-[500] text-[13px] leading-[24px] text-center text-[#262A29]">
							Done
						</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default PasswordChangedModal;
